import { Button, Col, Form, Input, InputNumber, notification, Row, Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
    addMedicalDataApi,
    editMedicalDataApi,
    listOfMenstrualHistoryApi,
    listOfRecipeTagsApi,
    listOfWeightLossApi,
    updateMedicalDataApi,
} from '../../../../../config/Api'
import {
    NUMBER_AND_FRACTIONAL_PATTERN,
    NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
} from '../../../../../config/constant'
import { FilterApiData } from '../../../../../services/FilterApiData'
import { BP_LIMITS, bpCategory } from '../../../../../services/BloodPressure'
import { blockNonDigitKeys } from '../../../../../services/InputKeys'
import { BpCategoryTag } from '../../../../../components/BpCategoryTag'
import { apiErrorMessage } from '../../../../../services/ApiError'
import '../../../Dashboard/style/AddNutritionistProgram.scss'

export const MedicalDetailsContent = (props) => {
    const [form] = Form.useForm()
    const { Option } = Select
    const { id } = useParams()

    const [menstrualHistoryOptions, setMenstrualHistoryOptions] = useState([])
    const [reasonOfWeightLossOptions, setReasonOfWeightLossOptions] = useState(
        []
    )
    const [diseasesOptions, setDiseasesOptions] = useState([])
    const [allergyTagOptions, setAllergyTagOptions] = useState([])
    const [existMedicalData, setExistMedicalData] = useState([])
    const [arrayOfSelectedDropdownValue, setArrayOfSelectedDropdownValue] =
        useState([])
    const [tagsList, setTagsList] = useState([])
    const [loading, setLoading] = useState(false)

    // blood pressure category follows the systolic / diastolic values
    const bpSystolic = Form.useWatch('bp_systolic', form)
    const bpDiastolic = Form.useWatch('bp_diastolic', form)
    useEffect(() => {
        form.setFieldsValue({
            blood_pressue_category: bpCategory(bpSystolic, bpDiastolic)?.label || '',
        })
    }, [form, bpSystolic, bpDiastolic])

    // filter the medical data tag list that already exist and return array of its tag ids
    //============================
    const tagArray = (type, medicalData) => {
        let selectedOption = []

        medicalData?.medical_history_tag_list?.map((tagData) => {
            tagData.tag_type == type && selectedOption.push(tagData.tag_id)
        })
        return selectedOption
    }

    //  get Patient Medical Data
    //============================
    const getPatientMedicalData = () => {
        setLoading(true)
        editMedicalDataApi(id)
            .then((res) => {
                if (res.status === 200) {
                    // console.log(res.data.data);
                    let medicalData = res.data.data

                    setExistMedicalData(res.data.data)
                    // console.log("edit called");

                    if (medicalData) {
                        setArrayOfSelectedDropdownValue(
                            medicalData?.medical_history_tag_list
                        )
                        form.setFieldsValue({
                            blood_group: medicalData?.blood_group,
                            rh_factor: medicalData?.rh_factor,
                            constipation: medicalData?.constipation,
                            gas: medicalData?.gas,
                            water_retention: medicalData?.water_retention,
                            sweet_tooth: medicalData?.sweet_tooth,
                            digestion_type: medicalData?.digestion_type,
                            energy_level: medicalData?.energy_level,
                            wheezing: medicalData?.wheezing,
                            acidity: medicalData?.acidity,
                            previous_weight_loss:
                                medicalData?.previous_weight_loss,
                            blood_pressue_category:
                                medicalData?.blood_pressue_category,
                            remark: medicalData?.remark,
                            reason_of_weight_loss:
                                medicalData?.reason_of_weight_loss_id ||
                                form.getFieldValue('reason_of_weight_loss'),
                            // numbers for the number inputs (older records may only have the dropdown name)
                            bp_systolic:
                                parseInt(medicalData?.bp_systolic_value ||
                                    medicalData?.bp_systolic?.name, 10) || undefined,
                            bp_diastolic:
                                parseInt(medicalData?.bp_diastolic_value ||
                                    medicalData?.bp_diastolic?.name, 10) || undefined,
                            menstrual_history:
                                medicalData?.menstrual_history_id,
                            allergy_tags: tagArray('allergy_tag', medicalData),
                            past_medical_history: tagArray(
                                'past_medical_history',
                                medicalData
                            ),
                            present_medical_problem: tagArray(
                                'present_medical_problem',
                                medicalData
                            ),
                            family_history_of_diseases: tagArray(
                                'family_history_of_diseases',
                                medicalData
                            ),
                        })
                    }
                    setLoading(false)
                }
            })
            .catch((err) => {
                setLoading(false)
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    // handle submit
    //============================
    const onFinish = (values) => {
        // console.log(values);
        const apiData = {
            blood_group: values.blood_group,
            rh_factor: values.rh_factor,
            constipation: values.constipation,
            gas: values.gas,
            water_retention: values.water_retention,
            sweet_tooth: values.sweet_tooth,
            digestion_type: values.digestion_type,
            energy_level: values.energy_level,
            wheezing: values.wheezing,
            acidity: values.acidity,
            previous_weight_loss: values.previous_weight_loss,
            blood_pressue_category: values.blood_pressue_category,
            remark: values.remark,
            medical_history_tag_list:
                arrayOfSelectedDropdownValue.length > 0
                    ? arrayOfSelectedDropdownValue
                    : [],
            reason_of_weight_loss_id: values.reason_of_weight_loss,
            bp_systolic_value: values.bp_systolic,
            bp_diastolic_value: values.bp_diastolic,
            menstrual_history_id: values.menstrual_history,
            patient_id: id,
        }
        // console.log(apiData);

        // if (!id) {
        if (!existMedicalData) {
            addMedicalDataApi(apiData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: 'Patient Medical Data added successfully',
                        })
                        getPatientMedicalData()
                        props.onSaved && props.onSaved()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: apiErrorMessage(err),
                    })
                })
        } else {
            updateMedicalDataApi(existMedicalData.id, apiData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message:
                                'Patient Medical Data Updated successfully',
                        })
                        getPatientMedicalData()
                        props.onSaved && props.onSaved()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: apiErrorMessage(err),
                    })
                })
        }
    }
    const resetData = () => {
        form.resetFields()
    }

    // code for common select dropdown options
    //============================
    const YesOrNoOption = (
        <>
            <Option value="Yes">Yes</Option>
            <Option value="No">No</Option>
        </>
    )

    useEffect(() => {
        getListOfMenstrualHistory()
        getListOfReasonOfWeightLoss()
        getListOfRecipeTags()

        // get the details of patient medical data if available
        getPatientMedicalData()
    }, [])

    // apis for dropdown data
    //============================
    const getListOfMenstrualHistory = () => {
        listOfMenstrualHistoryApi()
            .then((res) => {
                if (res.status === 200) {
                    setMenstrualHistoryOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }


    const getListOfReasonOfWeightLoss = () => {
        listOfWeightLossApi()
            .then((res) => {
                if (res.status === 200) {
                    const data = FilterApiData(res.data.data)
                    setReasonOfWeightLossOptions(data)

                    // If reason_of_weight_loss is not set, set it to "None" if found
                    const currentVal = form.getFieldValue(
                        'reason_of_weight_loss'
                    )
                    if (!currentVal || currentVal === '') {
                        const noneOption = data.find(
                            (opt) =>
                                opt.reason &&
                                opt.reason.toLowerCase() === 'none'
                        )
                        if (noneOption) {
                            form.setFieldsValue({
                                reason_of_weight_loss: noneOption.id,
                            })
                        }
                    }
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    // to get an allergy and Disease tags options
    const getListOfRecipeTags = () => {
        listOfRecipeTagsApi()
            .then((res) => {
                if (res.status === 200) {
                    const data = FilterApiData(res.data.data)
                    if (data && data.length > 0) {
                        setTagsList(res.data.data)
                    }
                    // console.log("tag list called");
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    // here create an array of object all tags related selected dropdown values
    // =================================
    const CreateArrayOfSelectedValue = (id, task, fieldName) => {
        // console.log(diseasesOptions);
        // console.log(task);
        // console.log(fieldName);
        let TagOptions = [...tagsList]
        // console.log(TagOptions);
        let object = {}
        object = TagOptions.find((element) => element.id == id)
        if (task == 'add') {
            // if selected option object is available inside array only push if not available
            let valueExist = arrayOfSelectedDropdownValue.find(
                (element) =>
                    element.tag_id == object.id && element.tag_type == fieldName
            )
            if (!valueExist) {
                let temp = { ...object }
                temp.tag_id = temp.id
                temp.tag_type = fieldName

                arrayOfSelectedDropdownValue.push(temp)
                setArrayOfSelectedDropdownValue(arrayOfSelectedDropdownValue)
            }
            // console.log(arrayOfSelectedDropdownValue);
        }
        if (task == 'remove') {
            // console.log("object id", object.id);
            const indexOfElement = arrayOfSelectedDropdownValue.findIndex(
                (record) =>
                    record.tag_id == object.id && record.tag_type == fieldName
            )
            arrayOfSelectedDropdownValue.splice(indexOfElement, 1)
            // console.log(arrayOfSelectedDropdownValue);
        }
    }
    return (
        <div className="AddNutritionistProgram">
            {/* {console.log(tagsList)} */}
            <Spin spinning={loading} className="spinner-code">
                <Form
                    name="AddNutritionistProgramForm"
                    className="AddNutritionistProgramForm"
                    form={form}
                    onFinish={onFinish}
                >
                    <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Select Blood Group
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="blood_group"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Blood Group!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Blood Group
                                    </Option>
                                    <Option value="A">A</Option>
                                    <Option value="B">B</Option>
                                    <Option value="AB">AB</Option>
                                    <Option value="O">O</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Select Rh Factor
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="rh_factor"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Rh Factor!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Rh Factor
                                    </Option>
                                    <Option value="+">+</Option>
                                    <Option value="-">-</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Constipation
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="constipation"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Constipation!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Constipation
                                    </Option>
                                    {YesOrNoOption}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Gas
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="gas"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Gas!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Gas
                                    </Option>
                                    {YesOrNoOption}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Water Retention
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="water_retention"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Gas!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Water Retention
                                    </Option>
                                    {YesOrNoOption}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Sweet Tooth
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="sweet_tooth"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Sweet Tooth!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Sweet Tooth
                                    </Option>
                                    {YesOrNoOption}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Digestion Type
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="digestion_type"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please Select Digestion Type!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Digestion Type
                                    </Option>
                                    <Option value="Normal">Normal</Option>
                                    <Option value="Sluggish">Sluggish</Option>
                                    <Option value="Sensitive">Sensitive</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Energy Level
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="energy_level"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Energy Level!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Energy Level
                                    </Option>
                                    <Option value="Good">Good</Option>
                                    <Option value="Moderate">Moderate</Option>
                                    <Option value="Low">Low</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Wheezing
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="wheezing"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Wheezing!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Wheezing
                                    </Option>
                                    {YesOrNoOption}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Acidity
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="acidity"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Acidity!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Acidity
                                    </Option>
                                    {YesOrNoOption}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Menstrual History
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="menstrual_history"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please Select Menstrual History!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Menstrual History
                                    </Option>
                                    {menstrualHistoryOptions.length > 0 &&
                                        menstrualHistoryOptions.map(
                                            (element, index) => (
                                                <Option
                                                    key={index}
                                                    value={element.id}
                                                >
                                                    {element.type}
                                                </Option>
                                            )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Previous Weight Loss(In Kg)
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="previous_weight_loss"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please Enter Previous Weight Loss!',
                                    },
                                    {
                                        pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                        message:
                                            NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Enter Previous Weight Loss"
                                    className="mt-2 p-2"
                                />
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Reason of Weight Loss
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="reason_of_weight_loss"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please Enter Previous Weight Loss!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Reason of Weight Loss
                                    </Option>
                                    {reasonOfWeightLossOptions.length > 0 &&
                                        reasonOfWeightLossOptions.map(
                                            (element, index) => (
                                                <Option
                                                    key={index}
                                                    value={element.id}
                                                >
                                                    {element.reason}
                                                </Option>
                                            )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Bp Systolic(mm Hg)
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            {/* whole numbers only, 60-250 */}
                            <Form.Item
                                name="bp_systolic"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Enter Bp Systolic',
                                    },
                                    {
                                        type: 'number',
                                        min: BP_LIMITS.systolic.min,
                                        max: BP_LIMITS.systolic.max,
                                        message: `Bp Systolic must be between ${BP_LIMITS.systolic.min} and ${BP_LIMITS.systolic.max}!`,
                                    },
                                ]}
                            >
                                <InputNumber
                                    placeholder="Enter Bp Systolic"
                                    className="mt-2 p-1 w-100"
                                    min={BP_LIMITS.systolic.min}
                                    max={BP_LIMITS.systolic.max}
                                    precision={0}
                                    controls={false}
                                    onKeyDown={blockNonDigitKeys}
                                />
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Bp Diastolic(mm Hg)
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            {/* whole numbers only, 40-150, lower than systolic */}
                            <Form.Item
                                name="bp_diastolic"
                                dependencies={['bp_systolic']}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Enter Bp Diastolic!',
                                    },
                                    {
                                        type: 'number',
                                        min: BP_LIMITS.diastolic.min,
                                        max: BP_LIMITS.diastolic.max,
                                        message: `Bp Diastolic must be between ${BP_LIMITS.diastolic.min} and ${BP_LIMITS.diastolic.max}!`,
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const systolic = getFieldValue('bp_systolic')
                                            if (value && systolic && value >= systolic) {
                                                return Promise.reject(new Error('Diastolic must be lower than systolic!'))
                                            }
                                            return Promise.resolve()
                                        },
                                    }),
                                ]}
                            >
                                <InputNumber
                                    placeholder="Enter Bp Diastolic"
                                    className="mt-2 p-1 w-100"
                                    min={BP_LIMITS.diastolic.min}
                                    max={BP_LIMITS.diastolic.max}
                                    precision={0}
                                    controls={false}
                                    onKeyDown={blockNonDigitKeys}
                                />
                            </Form.Item>
                        </Col>

                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={6}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Blood Pressure Category
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            {/* calculated from systolic / diastolic and saved with the form */}
                            <Form.Item name="blood_pressue_category" hidden>
                                <Input />
                            </Form.Item>
                            <div className="mt-2 p-2">
                                <BpCategoryTag systolic={bpSystolic} diastolic={bpDiastolic} />
                            </div>
                        </Col>
                        <Col xs={24} md={16} xl={11} xxl={6}>
                            <label className="form-input-label">
                                Allergy Tags
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="allergy_tags"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Allergy Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'add',
                                            'allergy_tag'
                                        )
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'remove',
                                            'allergy_tag'
                                        )
                                    }
                                    placeholder="Select Allergy Tags"
                                >
                                    {/* <Option value="" disabled hidden>
                                    Select Allergy Tags
                                </Option> */}
                                    {tagsList &&
                                        tagsList.length > 0 &&
                                        tagsList.map(
                                            (option) =>
                                                option.tagType ==
                                                    'Allergy Tags' && (
                                                    <Option
                                                        key={option.id}
                                                        value={option.id}
                                                    >
                                                        {option.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={12}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Present Medical Problem
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="present_medical_problem"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Select Present Medical Problem!',
                                    },
                                ]}
                                // initialValue=""
                            >
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'add',
                                            'present_medical_problem'
                                        )
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'remove',
                                            'present_medical_problem'
                                        )
                                    }
                                    placeholder="Select Present Medical Problem"
                                >
                                    <Option value="" disabled hidden>
                                        Select Present Medical Problem
                                    </Option>
                                    {tagsList.length > 0 &&
                                        tagsList.map(
                                            (option) =>
                                                option.tagType ==
                                                    'Disease Tags' && (
                                                    <Option
                                                        value={option.id}
                                                        key={option.id}
                                                    >
                                                        {option.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={12}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Family History of Diseases
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="family_history_of_diseases"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Select Family History of Diseases!',
                                    },
                                ]}
                                // initialValue=""
                            >
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    placeholder="Select Family History Of Diseases"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'add',
                                            'family_history_of_diseases'
                                        )
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'remove',
                                            'family_history_of_diseases'
                                        )
                                    }
                                >
                                    {/* <Option value="" disabled hidden>
                                    Select Family History Of Diseases
                                </Option> */}
                                    {tagsList.length > 0 &&
                                        tagsList.map(
                                            (option) =>
                                                option.tagType ==
                                                    'Disease Tags' && (
                                                    <Option
                                                        key={option.id}
                                                        value={option.id}
                                                    >
                                                        {option.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={16}
                            xl={11}
                            xxl={12}
                            className="align-self-center"
                        >
                            <label className="form-input-label">
                                Past Medical History
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="past_medical_history"
                                // rules={[
                                //     { required: false, message: "Please Select Past Medical History!" },
                                // ]}
                                // initialValue=""
                            >
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'add',
                                            'past_medical_history'
                                        )
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(
                                            e,
                                            'remove',
                                            'past_medical_history'
                                        )
                                    }
                                    placeholder="Select Past Medical History"
                                >
                                    {/* <Option value="" disabled hidden>
                                    Select Past Medical History
                                </Option> */}
                                    {tagsList.length > 0 &&
                                        tagsList.map(
                                            (option) =>
                                                option.tagType ==
                                                    'Disease Tags' && (
                                                    <Option
                                                        value={option.id}
                                                        key={option.id}
                                                    >
                                                        {option.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={16} xl={11} xxl={12}>
                            <label className="form-input-label">Notes</label>
                            <Form.Item
                                name="remark"
                                // rules={[
                                //     // { required: true, message: "Please insert Frequency of calls!" },
                                // ]}
                            >
                                <Input.TextArea
                                    placeholder="Enter Notes"
                                    // showCount
                                    // maxLength={100}
                                    className="mt-2 p-2"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24} className="text-center">
                            <Button
                                htmlType="submit"
                                className="submit-button b-0 rounded"
                            >
                                SAVE
                            </Button>
                            <Button
                                onClick={() => resetData()}
                                className="reset-button ms-4 b-0 rounded"
                            >
                                RESET
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </div>
    )
}
